import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { CommunityLinks } from "./CommunityLinks";

export function SiteFooter({ variant = "page" }: { variant?: "page" | "sidebar" }) {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const [visible, setVisible] = useState(true);
	const lastScrollY = useRef(0);

	useEffect(() => {
		setVisible(true);
		lastScrollY.current = window.scrollY;
	}, [pathname]);

	useEffect(() => {
		if (variant === "sidebar") return;
		lastScrollY.current = window.scrollY;
		function handleScroll() {
			const current = window.scrollY;
			const delta = current - lastScrollY.current;
			const viewportBottom = current + window.innerHeight;
			const pageHeight = document.documentElement.scrollHeight;
			const atPageBottom = pageHeight - viewportBottom <= 32;
			if (current <= 4 || delta < -2 || atPageBottom) setVisible(true);
			else if (delta > 2) setVisible(false);
			lastScrollY.current = current;
		}
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, [variant]);

	if (variant === "sidebar") return <footer className="discovery-footer-links">
		<CommunityLinks className="discovery-community" />
		<nav aria-label={t("footer.navigation")}>
			<Link to="/about">{t("layout.about")}</Link>
			<a href="mailto:support@muhaha.ai">{t("footer.support")}</a>
			<Link to="/privacy">{t("footer.privacy")}</Link>
			<Link to="/tos">{t("footer.terms")}</Link>
		</nav>
		<p>{t("footer.copyright")}</p>
	</footer>;

	return (
		<footer
			className={`muhaha-footer shrink-0 border-t border-white/10 bg-black/55 px-4 py-1.5 text-[10px] text-white/45 sm:px-7 lg:fixed lg:inset-x-0 lg:bottom-0 lg:z-20 lg:shadow-[0_-12px_35px_rgba(0,0,0,0.18)] lg:backdrop-blur-xl lg:transition-transform lg:duration-200 ${
				!visible ? "lg:translate-y-full" : "lg:translate-y-0"
			}`}
		>
			<div className="flex w-full flex-wrap items-center justify-between gap-x-4 gap-y-0.5">
				<p>{t("footer.copyright")}</p>
				<div className="flex flex-wrap items-center gap-x-3 gap-y-1">
					<nav
						aria-label={t("footer.navigation")}
						className="flex flex-wrap items-center gap-x-3 gap-y-1"
					>
						<Link to="/about" className="muhaha-footer-link">
							{t("layout.about")}
						</Link>
						<a href="mailto:support@muhaha.ai" className="muhaha-footer-link">
							{t("footer.support")}
						</a>
						<Link to="/privacy" className="muhaha-footer-link">
							{t("footer.privacy")}
						</Link>
						<Link to="/tos" className="muhaha-footer-link">
							{t("footer.terms")}
						</Link>
					</nav>
					<CommunityLinks compact className="flex items-center gap-0.5 border-l border-white/10 pl-2" />
				</div>
			</div>
		</footer>
	);
}
